<div class="table-global-row" [style.grid-template-columns]="gridTemplateColumns()">
  <span class="table-global-row__label" [style.grid-column]="'1 / ' + (labelSpan() + 1)">
    {{ label() }}
  </span>

  @for (col of toggleColumns(); track col.field) {
    <div class="table-global-row__cell">
      <mat-slide-toggle
        [checked]="values()[col.field]"
        (change)="onToggle(col.field)"
      ></mat-slide-toggle>
    </div>
  }

  @if (actionsWidth()) {
    <div class="table-global-row__cell"></div>
  }
</div>
